// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11315883480");
  window.gtag("event", "conversion", {
    send_to: ["<GOOGLE_ADS_CONVERSION_LABEL>"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
}

// ----------------- END PURCHASE SCRIPT --------------------------------------

// ----------------- START ADD_PAYMENT_INFO SCRIPT ----------------------------

// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});

// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants add Payment info script : ", e);
  }
}

// merchant script for `add_payment_info` will be pasted here
function merchantAddPaymentInfoCustomCode(params) {
  // paste the snippet out here
}

// ----------------- END ADD_PAYMENT_INFO SCRIPT ------------------------------

// ----------------- START BEGIN_CHECKOUT SCRIPT ------------------------------

// `breeze-initiate-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}

// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  // paste the snippet out here
}

// ----------------- END BEGIN_CHECKOUT SCRIPT --------------------------------